<template>
  <material-card flat class="v-card--material-chart" v-bind="$attrs" v-on="$listeners">
    <chartist
      :data="data"
      :event-handlers="eventHandlers"
      :options="options"
      :ratio="ratio"
      :responsive-options="responsiveOptions"
      :type="type"
    />

    <!-- Dodatkowa treść pod chartem -->
    <slot />

    <!-- Akcje pod chartem -->
    <slot slot="actions" name="actions" />
  </material-card>
</template>

<script>
import MaterialCard from './Card';

// @vuese
// Wykres
// @group Material
export default {
  components: {
    MaterialCard
  },
  inheritAttrs: false,

  props: {
    // dane wykresu
    data: {
      type: Object,
      default: () => ({})
    },
    // obsługa eventów
    eventHandlers: {
      type: Array,
      default: () => []
    },
    // opcje wykresu
    options: {
      type: Object,
      default: () => ({})
    },
    // wymiary wykresu
    ratio: {
      type: String,
      default: '1:5'
    },
    // opcje responsywności
    responsiveOptions: {
      type: Array,
      default: () => []
    },
    // typ wykresu
    type: {
      type: String,
      required: true,
      validator: v => ['Bar', 'Line', 'Pie'].includes(v)
    }
  }
};
</script>

<style>
.v-card--material-chart .ct-label {
  color: inherit;
  opacity: 1;
  font-size: 0.975rem;
  font-weight: 300;
}

.v-card--material-chart .ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
}
.v-card--material-chart .ct-series-a .ct-point,
.v-card--material-chart .ct-series-a .ct-line,
.v-card--material-chart .ct-series-a .ct-bar,
.v-card--material-chart .ct-series-a .ct-slice-donut {
  stroke: rgba(0, 0, 0, 0.6);
}
.v-card--material-chart .ct-series-a .ct-slice-pie,
.v-card--material-chart .ct-series-a .ct-area {
  fill: rgba(255, 255, 255, 0.4);
}

.v-card--material-chart .v-card__actions {
  margin: 0 20px 0;
  padding: 10px 0 10px;
  line-height: 22px;
}

.v-card--material-chart .v-card {
  border-radius: 6px;
  min-height: 160px;
  padding: 5px !important;
}

.ct-nodata {
  font-size: 1.5em;
  text-align: center;

  position: absolute;
  top: 40%;
}
</style>
